export default __webpack_public_path__ + "9316953af29555121d1a95b8fa555e42.svg";